import { render } from "./QuoteInformation.vue?vue&type=template&id=d658512e&lang=pug"
const script = {}

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__